

// nuevas funciones
export const setNewMontoInItems = async (newAmount, id, form) => {
    const newItems = form.items.map(it => {
        if (parseInt(it.id) === parseInt(id)) {
            return {
                ...it,
                precio_unitario: newAmount,
                subtotal: newAmount,
            }
        }
        return it
    })

    return newItems

}

export const getFinalTotals = async (dataForm, items) => {

    const { impuesto_porcentaje, impuesto_tipo_calculo } = dataForm

    let sumaSubtotal = 0
    for (let x = 0; x < items.length; x++) {
        sumaSubtotal += items[x].subtotal
    }

    const factorImpuesto = (impuesto_porcentaje ? (parseFloat(impuesto_porcentaje) / 100) : 0);

    const subtotal = sumaSubtotal
    const descuento = 0
    const montoBase = subtotal - descuento
    let totalImpuesto = montoBase * factorImpuesto

    let totalFactura = 0
    if (impuesto_tipo_calculo === 'retencion') {
        totalFactura = montoBase - totalImpuesto
    } else {
        totalFactura = montoBase + totalImpuesto
    }

    totalImpuesto = parseFloat(totalImpuesto.toFixed(2))
    totalFactura = parseFloat(totalFactura.toFixed(2))

    return {
        subtotal: subtotal,
        descuento: descuento,
        monto_base: montoBase,
        total_impuesto: totalImpuesto,
        total_factura: totalFactura
    }

}

export const getInfoTipoDoc = async (listaTiposDocumentos, tipoDocId) => {

    const infoFound = listaTiposDocumentos.find(d => d.id === tipoDocId)

    if (infoFound) {
        return {
            impuesto_nombre: infoFound.impuestos[0].nombre_impuesto,
            impuesto_porcentaje: parseFloat(infoFound.impuestos[0].porcentaje_impuesto),
            impuesto_tipo_calculo: infoFound.impuestos[0].tipo_calculo,
        }
    }

    return {
        impuesto_nombre: null,
        impuesto_porcentaje: 0,
        impuesto_tipo_calculo: null
    }


}

export const setNewItemsValues = async (changedData) => {

    const { target, floatValue, items, itemId } = changedData

    const newItems = items.map(it => {
        console.log(it.id, itemId)
        if (parseInt(it.id) === parseInt(itemId)) {
            let newItem = it
            if (target === 'cantidad') newItem.cantidad = floatValue
            if (target === 'precio_unitario') newItem.precio_unitario = floatValue
            newItem.subtotal = newItem.cantidad * newItem.precio_unitario

            return newItem
        }

        return it

    });

    return newItems

}

export const setNewItemsName = async (newName, itemId, items) => {

    const newItems = items.map(it => {
        console.log(it.id, itemId)

        if (parseInt(it.id) === parseInt(itemId)) {
            return {
                ...it,
                nombre: newName
            }
        }

        return it

    });

    return newItems

}


export const calcDetraccion = async (dataForm) => {

    const { porcentaje_detraccion, totalFactura, valor_tipo_cambio, id_moneda, id_tipo_documento } = dataForm
    // console.log({ totalFactura, id_tipo_documento })

    const totalSolesFactura = parseFloat(totalFactura || 0) * parseFloat(valor_tipo_cambio || 1)
    // console.log({ totalSolesFactura })

    if (totalSolesFactura > 700 && parseInt(id_tipo_documento) === 1) {

        const porcentaje = (porcentaje_detraccion === 0 ? 12 : parseFloat(porcentaje_detraccion))
        let totalDetraccion = parseFloat(totalFactura || 0) * ((porcentaje || 0) / 100)
        if (parseInt(id_moneda) === 4) {
            totalDetraccion = totalDetraccion * parseFloat(valor_tipo_cambio || 0)
        }

        return {
            aplica_detraccion: true,
            porcentaje_detraccion: porcentaje,
            total_detraccion: totalDetraccion
        }

    } else {

        return {
            aplica_detraccion: false,
            porcentaje_detraccion: 0,
            total_detraccion: 0
        }

    }

}